import { render } from "./public-directory.vue?vue&type=template&id=4dd55dd8&scoped=true"
import script from "./public-directory.vue?vue&type=script&lang=js"
export * from "./public-directory.vue?vue&type=script&lang=js"

import "./public-directory.vue?vue&type=style&index=0&id=4dd55dd8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd55dd8"]])

export default __exports__